import { jsx as _jsx } from "react/jsx-runtime";
import { OVERLAY_COLOR_HEX } from "../utils";
const CHIP_CLASS = "px-1.5 py-0.5 rounded-full text-[9px] font-medium leading-tight text-white";
/**
 * The overlay chip row for a node: the badge list when there is one, otherwise
 * the single label. Renders nothing when the node carries neither, so a node
 * without an overlay keeps its exact geometry.
 *
 * `anchor` is required and has no default on purpose: the rectangular activity
 * card's top-right corner is the shape's own corner, while a diamond's is empty
 * space away from the outline — and a row anchored there grows across the
 * gateway's step-number chip. Each node kind names the offsets its own shape
 * needs.
 */ export function NodeOverlayLabel({ color, label, badges, anchor }) {
    if (badges && badges.length > 0) {
        return /*#__PURE__*/ _jsx("div", {
            className: "absolute flex gap-0.5 pointer-events-none",
            style: anchor,
            children: badges.map((badge)=>/*#__PURE__*/ _jsx("div", {
                    className: CHIP_CLASS,
                    style: {
                        backgroundColor: OVERLAY_COLOR_HEX[badge.color].stroke
                    },
                    children: badge.label
                }, `${badge.color}:${badge.label}`))
        });
    }
    if (!label) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: `absolute pointer-events-none ${CHIP_CLASS}`,
        style: {
            ...anchor,
            backgroundColor: OVERLAY_COLOR_HEX[color ?? "gray"].stroke
        },
        children: label
    });
}

//# sourceMappingURL=NodeOverlayLabel.js.map